import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import { textStyles } from '@marketing-sites/ui'
import type { FeaturedArticleListItemFragment } from '../../../.graphql/generated-types'
import type { Substitutions } from '../../components/ContentfulRichText'
import { ContentfulRichText } from '../../components/ContentfulRichText'
import { TopicTags } from '../TopicTags'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'
import { LinkToArticlePage } from '../LinkToArticlePage'

export interface FeaturedArticleListItemProps {
  data: FeaturedArticleListItemFragment
  substitutions: Substitutions
}

export function FeaturedArticleListItem({
  data,
  substitutions,
}: FeaturedArticleListItemProps) {
  const name = data.heading ?? data.name
  const { slug } = data
  if (name && slug) {
    return (
      <div className="w-full border border-blog-dusty-black-100 bg-white hover:shadow-[0px_0px_10px_rgba(0,0,0,0.16)] md:flex">
        <div className="p-4 md:flex-1">
          {data.topicsCollection && <TopicTags data={data.topicsCollection} />}

          <h3 className="mb-2 text-xl font-bold text-blog-oceany-blue-300">
            <LinkToArticlePage article={data}>{name}</LinkToArticlePage>
          </h3>
          {data.excerpt?.json && (
            <div className="text-blog-dusty-black-300">
              <ContentfulRichText
                document={data.excerpt.json as Document}
                substitutions={substitutions}
              />
            </div>
          )}
          <p className="my-6 text-left">
            <LinkToArticlePage article={data} className={textStyles.a}>
              <span aria-label={`Read the article - ${name}`}>
                Read the Article
              </span>
            </LinkToArticlePage>
          </p>
        </div>
        {data.heroImage?.imageAsset?.url && (
          <div className="md:w-2/3">
            <LinkToArticlePage
              article={data}
              className="block w-full md:h-full"
            >
              <div className="relative h-56 md:h-full md:w-full">
                <ContentfulImageWithPlaceholder
                  alt={data.heroImage.altText ?? ''}
                  src={data.heroImage.imageAsset.url}
                  width={624}
                  height={351}
                  fill
                  sizes="100vw"
                  className="object-cover"
                />
              </div>
            </LinkToArticlePage>
          </div>
        )}
      </div>
    )
  }
  return null
}
